<template>
  <v-dialog
    v-model="showModal"
    persistent
    max-width="700px"
    @keydown.enter.prevent="submit()"
    @keydown.esc.prevent="cancel()"
  >
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1 mb-2">
        <h2>{{ showTitle }}</h2>
      </v-card-title>
      <v-card-text class="pt-2 pb-2">
        <v-card class="mb-2 py-4">
          <v-card-text>
            <template v-if="isText">
              <v-row no-gutters>
                <v-col cols="12" v-html="text"></v-col>
              </v-row>
            </template>
            <template v-if="isError || isWarning">
              <v-row no-gutters>
                <v-col cols="12">
                  <v-alert class="py-5" dense outlined :type="type">
                    {{ text }}
                  </v-alert>
                </v-col>
              </v-row>
            </template>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions class="modalActions" elevation="5">
        <v-spacer></v-spacer>
        <el-button @click.native.stop="submit()">
          Uždaryti
        </el-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalInfo',
  props: {
    title: String,
    text: String,
    type: String,
    value: Boolean,
  },
  data() {
    return {}
  },
  computed: {
    showTitle() {
      return this.title
    },
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    modalAction() {
      return 'Submit'
    },
    isError() {
      return this.type === 'error'
    },
    isWarning() {
      return this.type === 'warning'
    },
    isText() {
      return this.type === 'text'
    },
  },
  methods: {
    closeModal() {
      this.showModal = false
    },
    submit() {
      this.$emit('confirm' + this.modalAction)
      this.closeModal()
    },
    cancel() {
      this.submit()
    },
  },
}
</script>
<style lang="scss" scoped>
.modalCard {
  background: #f5f5f5 !important;
}
.modalTitle {
  background: #f5f5f5 !important;
  position: sticky;
  top: 0;
  z-index: 2;
  background: none;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.modalActions {
  position: sticky;
  bottom: 0;
  z-index: 1;
}
</style>
